import { Skeleton, SxProps, Typography, TypographyPropsVariantOverrides } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { OverridableStringUnion } from '@mui/types';
import color from '@theme/Colors';
import { Fragment, ReactNode } from 'react';

type BasePropsTextSkeleton = {
    conditions: boolean;
    loadingStyle?: SxProps;
    textStyle?: SxProps;
    value: ReactNode;
    variant?: OverridableStringUnion<Variant | 'inherit', TypographyPropsVariantOverrides>;
};
export default function LoadingTextSkeleton(props: BasePropsTextSkeleton) {
    const { conditions, loadingStyle, textStyle, value } = props;
    return (
        <Fragment>
            {conditions ? (
                <Skeleton
                    animation="wave"
                    sx={{
                        borderRadius: '4px',
                        backgroundColor: color.grey200,
                        ...loadingStyle,
                    }}
                />
            ) : (
                <Typography
                    variant={props.variant ?? 'inherit'}
                    sx={{
                        ...textStyle,
                    }}
                >
                    {value}
                </Typography>
            )}
        </Fragment>
    );
}
